import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="copyright">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <p style={{textAlign:"center"}}>Copyrights ©2019: Thaioil Cooperative Savinvgs</p>
              </div>
              {/* <div className="col-sm-4 text-right" /> */}
            </div>
          </div>
        </div>
      </footer>

    );
  }
}

export default Footer;
